module.exports = __webpack_public_path__ + "img/fig23.c7ca993f.jpg";